<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Forms'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Forms'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'forms/index',
            deleteItem: 'forms/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/forms/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/forms/add');
        }
    }
};
</script>
